import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type {
  BatteryProposalDto,
  UpdateBatteryProposalTariffDto,
} from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useUpdateBatteryProposalTariff(): UseMutationResult<
  BatteryProposalDto,
  unknown,
  { proposalId: string; body: UpdateBatteryProposalTariffDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.updateTariff(proposalId, body),
    onSuccess: (proposal, { proposalId, body }) => {
      queryClient.setQueryData(
        queryKeys.batteryProposal.byId(proposalId),
        proposal,
      )
      void queryClient.invalidateQueries({
        queryKey: queryKeys.batteryProposal.all,
      })
      if (body.lseId != null) {
        void queryClient.invalidateQueries({
          queryKey: queryKeys.batteryProposal.genabilityAccounts,
        })
      }
    },
  })
}
